export default __webpack_public_path__ + "static/media/fad-mono.178c820f.svg";